import BooleanEditor from "./BooleanEditor.js";
import IntEditor from "./IntEditor.js";
import ObjectEditor from "./ObjectEditor.js";
import StringEditor from "./StringEditor.js";
import TimestampEditor from "./TimestampEditor.js";
import EnumEditor from "./EnumEditor.js";
import PasswordEditor from "./PasswordEditor.js";
const install = molten => {
  molten.addPlugin('OpenApiAttributeEditor', BooleanEditor);
  molten.addPlugin('OpenApiAttributeEditor', IntEditor);
  molten.addPlugin('OpenApiAttributeEditor', StringEditor);
  molten.addPlugin('OpenApiAttributeEditor', TimestampEditor);
  molten.addPlugin('OpenApiAttributeEditor', ObjectEditor);
  molten.addPlugin('OpenApiAttributeEditor', EnumEditor);
  molten.addPlugin('OpenApiAttributeEditor', PasswordEditor);
};
export { install };
export default {
  install
};